export function maxLength(length: number, messageKey?: string) {
  return (value: string) => {
    return value && value.length > length && (messageKey || 'MaxlengthError');
  };
}
